import { useRef } from "react";
import { motion } from "framer-motion";
import { Canvas, useFrame } from "@react-three/fiber";
import { Environment, Lightformer } from "@react-three/drei";
import LogoMark3D from "./three/LogoMark3D";

const RotatingMark = () => {
  const ref = useRef();
  useFrame((_, delta) => {
    if (ref.current) ref.current.rotation.y += delta * 1.1;
  });
  return (
    <group ref={ref}>
      <LogoMark3D scale={2.1} />
    </group>
  );
};

const Loader = () => (
  <motion.div
    data-testid="loading-screen"
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505]"
    exit={{ opacity: 0, filter: "blur(12px)", scale: 1.03 }}
    transition={{ duration: 0.7, ease: [0.65, 0, 0.35, 1] }}
  >
    <motion.div
      className="h-[240px] w-[240px] sm:h-[300px] sm:w-[300px]"
      initial={{ opacity: 0, scale: 0.8, filter: "blur(12px)" }}
      animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
    >
      <Canvas dpr={[1, 1.5]} camera={{ position: [0, 0, 7], fov: 42 }} gl={{ antialias: true, alpha: true }}>
        <RotatingMark />
        <ambientLight intensity={0.3} />
        <spotLight position={[5, 6, 6]} angle={0.5} penumbra={1} intensity={160} color="#ffffff" />
        <Environment resolution={256} frames={1}>
          <Lightformer intensity={3.5} position={[0, 5, -6]} scale={[12, 4, 1]} color="#ffffff" />
          <Lightformer intensity={2.2} position={[-6, 2, 2]} rotation-y={Math.PI / 2} scale={[8, 2.5, 1]} color="#e8e8e8" />
          <Lightformer intensity={2.2} position={[6, -1, 2]} rotation-y={-Math.PI / 2} scale={[8, 2.5, 1]} color="#ffffff" />
        </Environment>
      </Canvas>
    </motion.div>
    <motion.p
      data-testid="loader-tagline"
      className="font-display mt-2 text-[10px] sm:text-xs font-light tracking-[0.4em] text-white/70 text-center px-6"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
    >
      DON'T COMPETE FOR ATTENTION. COMMAND IT.
    </motion.p>
  </motion.div>
);

export default Loader;
